/**
 * Constantes de timing pour les widgets
 * Centralise tous les délais utilisés dans l'application pour faciliter la maintenance
 * @module constants/timing
 */

export const TIMING = {
  /** Délai de debounce pour les messages de resize (ms) */
  DEBOUNCE_RESIZE: 200,

  /** Tolérance en pixels pour éviter les updates inutiles */
  RESIZE_TOLERANCE: 10,

  /** Délai de reset du flag resizeInProgress (ms) */
  RESIZE_PROGRESS_RESET: 150,

  /** Délai pour updateHeight() (ms) */
  UPDATE_HEIGHT_DELAY: 50,

  /** Délai après changement de contenu (ms) */
  CONTENT_CHANGE_DELAY: 300,

  /** Délai pour transitions entre étapes (ms) */
  STEP_TRANSITION: 50,

  /** Délai pour goToStep direct (ms) */
  STEP_GOTO_TRANSITION: 30,

  /** Durée des animations modal/fade (ms) */
  ANIMATION_DURATION: 300,

  /** Délai pour recalcul hauteur mobile (ms) */
  MOBILE_HEIGHT_RECALC: 300,

  /** Délai après fin de chargement (ms) */
  END_LOADING_DELAY: 100,

  /** Délai initial au montage (ms) */
  INITIAL_RESIZE_DELAY: 200,
};
